const sandboxUrl = 'http://localhost:3001';
const productionUrl = 'https://sso-dashboard.manforce.com.my';

export type Options = {
    environment?: 'sandbox' | 'production';
    baseUrl?: string;
    platformId: string;
    platformName: string;
    autoLink?: boolean;
};

export type LoginResponse = {
    userId?: string;
    data: {
        id: string;
        name: string;
        email: string;
        token: string;
    } | null;
    error?: string;
};

export default class MSSOClient {
    private baseUrl: string;
    private platformId: string;
    private platformName: string;
    private autoLink?: boolean;
    constructor(options: Options) {
        if (!options.platformId) {
            throw new Error('Platform id is required');
        }
        if (!options.platformName) {
            throw new Error('Platform Name is required');
        }
        this.baseUrl =
            options?.baseUrl || (options?.environment === 'sandbox' ? sandboxUrl : productionUrl);
        this.platformId = options.platformId;
        this.platformName = options.platformName;
        this.autoLink = options.autoLink;
    }

    async login(userId?: string): Promise<LoginResponse> {
        return new Promise((resolve) => {
            const data: Record<string, any> = { userId, platformId: this.platformId, platformName: this.platformName, timestamp: Date.now() };
            if (this.autoLink) {
                data.autoLink = true;
            }
            const payload = btoa(JSON.stringify(data));

            const response: LoginResponse = {
                userId,
                data: null,
            };

            const newWindow = window.open(
                `${this.baseUrl}/sso?payload=${payload}&origin=${location.origin}`,
                '_blank',
                'toolbar=no, location=no, directories=no,popup=true, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no,resizable=false,width=440,height=560',
            );

            const listener = (event: MessageEvent<any>) => {
                if (event.origin === this.baseUrl) {
                    if (event.data?.type === 'login') {
                        response.data = event.data.payload;
                    }
                }
            };

            window?.addEventListener('message', listener);

            const interval = setInterval(() => {

                if (newWindow === null || newWindow.closed) {
                    window.removeEventListener('message', listener);
                    resolve(response);
                    clearInterval(interval);
                    return;
                }
            });
        });
    }
}

if (typeof window !== 'undefined') {
    (window as any).MSSOClient = MSSOClient;
}
